import O2oMultiEvaluateDialog from './src/main';

/* istanbul ignore next */
O2oMultiEvaluateDialog.install = function(Vue) {
  Vue.component(O2oMultiEvaluateDialog.name, O2oMultiEvaluateDialog);
};

export default O2oMultiEvaluateDialog;
